<template>
  <vx-tooltip :text="$t('edit')" position="bottom">
    <vs-button class="text-center editButton" color="primary" type="border" icon-pack="feather" icon="icon-edit" size="small" @click.prevent="click"></vs-button>
  </vx-tooltip>
</template>

<script>
export default {
  name: 'EditButton',
  methods: {
    click () {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>

</style>
